import NewsHeader from './NewsHeader';

export default NewsHeader;
